import React, { useState, useRef } from "react";
import axios from "axios";
import "../styles/applicationform.css";

const ApplicationForm = () => {
  const formRef = useRef();

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [experience, setExperience] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    position: "",
    certificate: null,
    resume: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!experience) {
      alert("Select experience");
      return;
    }

    const BASE_URL =
      window.location.hostname === "localhost"
        ? "http://localhost:5000"
        : process.env.REACT_APP_BACKEND_URL;

    setLoading(true);

    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("position", formData.position);
      data.append("experience", experience);
      data.append("certificate", formData.certificate);
      data.append("resume", formData.resume);

      await axios.post(`${BASE_URL}/api/applications`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setSubmitted(true);
      formRef.current.reset();
      setExperience("");

      setTimeout(() => setSubmitted(false), 3000);

    } catch (err) {
      console.error(err);
      alert("❌ Submission failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      {submitted && (
        <div className="popup-message">
          ✅ Application submitted successfully!
        </div>
      )}

      <form ref={formRef} onSubmit={handleSubmit}>
        <h2>Application Form</h2>

        <input name="name" placeholder="Name" required onChange={handleChange} />

        <input
          name="email"
          type="email"
          placeholder="Email"
          required
          onChange={handleChange}
        />

        <input
          name="position"
          placeholder="Position"
          required
          onChange={handleChange}
        />

        <select
          value={experience}
          onChange={(e) => setExperience(e.target.value)}
          required
        >
          <option value="">Select Experience</option>
          <option value="fresher">Fresher</option>
          <option value="experienced">Experienced</option>
          <option value="internship">Internship</option>
        </select>

        <label>
          Certificate:
          <input
            type="file"
            name="certificate"
            required
            onChange={handleChange}
          />
        </label>

        <label>
          Resume:
          <input
            type="file"
            name="resume"
            required
            onChange={handleChange}
          />
        </label>

        <button disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default ApplicationForm;